<div class="customPanel">
  <h1 style="text-align: center; height: 7%" mat-dialog-title>
    {{this.localiser.get("devices.editGateway")}} {{selectedConcentradorToEdit.idDispositivo}}
  </h1>

  <div mat-dialog-content class="bodyForm">

    <div class="row rowForm">
      <div class="col">
        <h5 class="textS+">{{this.localiser.get("devices.name")}}</h5>
        <input [(ngModel)]="name" type="text" class="inputWidth textS+">
      </div>
    </div>

    <div class="row rowForm textS+">

      <div class="col-3">
        <h5 class="textS+">{{this.localiser.get("devices.project")}}</h5>
        <mat-form-field style="width: 90%;" color="primary" appearance="fill">
          <mat-label class="textS+">{{this.localiser.get("devices.project")}}</mat-label>
          <mat-select class="textS+" (selectionChange)="selectProyecto($event)" [(ngModel)]="proyectoSelected">
            <mat-option *ngFor="let proyecto of user.getProyectos()"
                        [value]="proyecto">{{proyecto.nombre}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-3">
        <h5 class="textS+">{{this.localiser.get("devices.floorplan")}}</h5>
        <mat-form-field style="width: 90%;" appearance="fill">
          <mat-label class="textS+">{{this.localiser.get("devices.floorplan")}}</mat-label>
          <mat-select class="textS+" (selectionChange)="selectPlano($event)" [(ngModel)]="planoSelected">
            <mat-option *ngFor="let plano of showPlanos"
                        [value]="plano">{{plano.nombre}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-3">
        <h5 class="textS+">{{this.localiser.get("devices.zone")}}</h5>
        <mat-form-field style="width: 90%;" color="warn" appearance="fill">
          <mat-label class="textS+">{{this.localiser.get("devices.zone")}}</mat-label>
          <mat-select class="textS+" (selectionChange)="selectZona($event)" [(ngModel)]="zonaSelected">
            <mat-option *ngFor="let zona of showZonas" [value]="zona">{{zona.nombre}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-3" style="text-align: center; margin: auto">
        <button style="top: 30%; width: 70%" class="customButtonColor textS" mat-button (click)="removeLocation()"
                [disabled]="proyectoSelected == null || proyectoSelected == undefined">
          <h3 class="textS" style="margin: 3%; color: black;">{{this.localiser.get("devices.removeLocation")}}</h3>
        </button>
      </div>

    </div>
    <div class="row rowForm textS+">
      <div class="col-3" [matTooltip]="getStatusLockMessage()">
        <h5 class="textS+">{{this.localiser.get("devices.activestatus")}}</h5>
        <mat-form-field style="width: 90%;" color="warn" appearance="fill">
          <mat-label class="textS+">{{this.localiser.get("devices.activestatus")}}</mat-label>
          <mat-select class="textS+" [(ngModel)]="selectedConcentradorToEdit.activo"
                      [disabled]="isStatusLocked()">
            <mat-option [value]="true">{{this.localiser.get("devices.activestatus.active")}}</mat-option>
            <mat-option [value]="false">{{this.localiser.get("devices.activestatus.inactive")}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="checkGatewayType(this.selectedConcentradorToEdit) != 'FF'" class="col-6 marginAuto">
        <h5 class="textS+">{{this.localiser.get("devices.otaGateway")}}</h5>
        <mat-form-field style="width: 90%;" color="primary" appearance="fill">
          <mat-label class="textS+">{{this.localiser.get("devices.otaGateway")}}</mat-label>
          <mat-select class="textS" (selectionChange)="selectConcentradorMantenimiento($event)" [(ngModel)]="concentradorMantenimientoSelected">
            <mat-option [value]="-1">{{this.localiser.get("devices.none")}}</mat-option>
            <mat-option *ngFor="let concentrador of this.concentradoresMantenimiento"
                        [value]="concentrador">{{concentrador.nombre}} ({{concentrador.idDispositivo}})</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <h3 *ngIf="otaActive" class="textS+ otaActiveWarning">
        <span class="material-icons-outlined textM">warning</span>
        {{this.localiser.get("devices.otaActiveWarning")}}
      </h3>
    </div>

    <div class="row">
      <h3 *ngIf="activationBlocked" class="textS+ otaActiveWarning">
        <span class="material-icons-outlined textM">warning</span>
        {{this.localiser.get("devices.duplicatePanIdWarning")}}
      </h3>
    </div>

    <div class="row">
      <h3 *ngIf="changingProyecto && checkGatewayType(this.selectedConcentradorToEdit) != 'FF'" class="textS+" style="color: #F2A356; text-align: center; margin: auto;">
        If you change the project, all the groups of this gateway will be deleted
      </h3>
    </div>

  </div>

  <div mat-dialog-actions>
    <div class="col" style="text-align: center">
      <button class="customButtonColor" mat-button (click)="onCancelClick()">{{this.localiser.get("devices.cancel")}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button class="customButtonColor" mat-button (click)="onSaveClick()">{{this.localiser.get("devices.save")}}</button>
    </div>
  </div>


</div>
